/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerCompanyUpdateVatExemptionRequest
 */
export interface FreelancerCompanyUpdateVatExemptionRequest {
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerCompanyUpdateVatExemptionRequest
     */
    isVatExempted: boolean;
}

/**
 * Check if a given object implements the FreelancerCompanyUpdateVatExemptionRequest interface.
 */
export function instanceOfFreelancerCompanyUpdateVatExemptionRequest(value: object): value is FreelancerCompanyUpdateVatExemptionRequest {
    if (!('isVatExempted' in value) || value['isVatExempted'] === undefined) return false;
    return true;
}

export function FreelancerCompanyUpdateVatExemptionRequestFromJSON(json: any): FreelancerCompanyUpdateVatExemptionRequest {
    return FreelancerCompanyUpdateVatExemptionRequestFromJSONTyped(json, false);
}

export function FreelancerCompanyUpdateVatExemptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyUpdateVatExemptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isVatExempted': json['isVatExempted'],
    };
}

export function FreelancerCompanyUpdateVatExemptionRequestToJSON(value?: FreelancerCompanyUpdateVatExemptionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isVatExempted': value['isVatExempted'],
    };
}

